module.exports = __webpack_public_path__ + "img/project-9.454925ae.jpg";